import { IRequestType } from '@interfaces/request';
import React from 'react';
import { ITaggedImage } from '../../../../interfaces/IElements';
import { SectionHeadline } from '../../../components/atoms/section-headline/section-headline';
import { DeviceContext } from '../../../contexts/device/device';
import { theme } from '../../../style/global-style';
import { eventTracker } from '../../../utils/EventTracker';
import { numberFormat, replaceVal } from '../../../utils/formatting';
import { __ } from '../../../utils/translation-service';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { IUGCLabelProps } from '../../atoms/label-box/label-box';
import { OfferBoardCard } from '../../molecules/offer-board-card/offer-board-card';
import {
    StyledButtonWrapper,
    StyledCardsComponent,
    StyledCardsWrapper,
    StyledOuterWrapper,
    StyledTeaserWrapper,
    StyledHeaderWrapper,
} from './offer-teaser.style';

export interface IOfferTeaserItem {
    nid: number;
    startHarbour: string;
    shipName: string;
    numOfNights: number;
    numOfPorts: number;
    numOfDaysAtSea?: number;
    images: ITaggedImage[];
    companyLogo: string;
    companyName: string;
    ratingValue: number;
    ratingString: string;
    ratingCount: number;
    minPrice: number;
    discount: number;
    visits?: number;
    cabinStockThreshold: number;
    withFlight?: boolean;
    cheapestCabinType?: string;
    highlights: string[];
    icons: { icon: string; text: string }[];
    departureDate: string;
    returnDate: string;
    numOfSails: number;
    textLabelItems: IUGCLabelProps[];
    totalStock?: number;
    onBoardCredit?: number;
    redirectUrl: string;
    highDemand: boolean;
    requestType: IRequestType;
    cardNum: number;
}

interface IOfferTeaser {
    headline: string;
    items: IOfferTeaserItem[];
    totalOfferCount: number;
    searchUrl: string;
    requestType: IRequestType;
}

export const OfferTeaser = (props: IOfferTeaser) => {
    const { totalOfferCount, headline, items, requestType, searchUrl } = props;
    const formattedOfferCount =
        totalOfferCount &&
        totalOfferCount > 0 &&
        replaceVal(__('seeAllOffers'), numberFormat(totalOfferCount));
    const device = React.useContext(DeviceContext);
    const limit = device === 'mobile' ? 3 : 6;
    return (
        <StyledOuterWrapper>
            <StyledHeaderWrapper>
                <SectionHeadline firstChunk={headline} secondChunk={__('deals')} />
            </StyledHeaderWrapper>
            <StyledTeaserWrapper>
                <StyledCardsWrapper>
                    <StyledCardsComponent count={totalOfferCount}>
                        {items.map((el, i) => (
                            <OfferBoardCard
                                key={i}
                                {...el}
                                requestType={requestType}
                                cardNum={i + 1}
                            />
                        ))}
                    </StyledCardsComponent>
                </StyledCardsWrapper>

                {totalOfferCount > limit && (
                    <StyledButtonWrapper>
                        <DreamlinesButton
                            primary
                            style={{
                                fontSize: theme.fontSize.copyTextXL,
                                fontWeight: 600,
                                height: '45px',
                                position: 'relative',
                                padding: '6px 33px',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                eventTracker.track({
                                    event: 'click',
                                    category: 'offers-teasers',
                                    action: `all-offers-button`,
                                    label: `${requestType}-${headline}`,
                                });
                                // @TODO Router is not working with full urls, find a solution later
                                window.location.href = searchUrl;
                            }}
                            domType="div"
                        >
                            {formattedOfferCount}
                        </DreamlinesButton>
                    </StyledButtonWrapper>
                )}
            </StyledTeaserWrapper>
        </StyledOuterWrapper>
    );
};
